import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export const fetchScannerFilterTags = async () => {
  const url = `${backendUrl}/api/screener/filter/tags/`;
  
  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Ошибка при получении тегов фильтра');
    }
    return await response.json();
  } catch (error) {
    console.error('Ошибка при отправке GET запроса на /api/screener/filter/tags/:', error);
    throw error;
  }
};